import { statusColor } from "@/lib/format";

export default function StatusPill({ status, testId }) {
  const c = statusColor(status);
  return (
    <span data-testid={testId} className="status-pill" style={{ backgroundColor: c.bg, color: c.fg }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: c.dot }} />
      {status}
    </span>
  );
}
